import {initiateCall, initiateVideoSession, saveSessionCoordinates} from "../../services/apollo/call";

export default {
  namespaced: true,
  actions: {
    startCall({commit}, {contact, shouldRecord}) {
      return initiateCall(contact.id, shouldRecord)
        .then(({initiateCall: {room, call}}) => {
          commit('addActiveCall', {room, call, contact, shouldRecord});
          return call.callSid
        })
    },
    autoConnectToCall({commit}, {contact, room, call, shouldRecord}) {
      commit('addAutoConnectActiveCall', {room, call, contact, shouldRecord});
    },
    startVideoSession({commit}, phone) {
      return initiateVideoSession(phone)
        .then((session) => {
          commit('addActiveVideoSession', session);
          return session
        })
    },
    updateCallStatus({commit}, {callSid, status}) {
      commit('changeCallStatus', {callSid, status});
    },
    saveSessionCoordinates({commit}, {callSid, coordinates}) {
      return saveSessionCoordinates(callSid, coordinates);
    }
  },
  mutations: {
    addActiveCall(state, {room, call, contact, shouldRecord}) {
      state.activeCalls = {
        ...state.activeCalls,
        [call.callSid]: {
          room,
          status: state.activeCalls[call.callSid] ? state.activeCalls[call.callSid].status : 'initiated',
          contact,
          recording: shouldRecord,
          duration: 0
        }
      };
    },

    addAutoConnectActiveCall(state, {room, call, contact, shouldRecord}) {
      state.activeCalls = {
        ...state.activeCalls,
        [call.callSid]: {
          room,
          status: 'auto_connect',
          contact,
          recording: shouldRecord,
          duration: 0
        }
      };
    },

    addActiveVideoSession(state, {room, sessionId}) {
      state.activeVideoSessions = {
        ...state.activeVideoSessions,
        [sessionId]: room
      };
    },

    changeCallStatus(state, {callSid, status}) {
      state.activeCalls = {
        ...state.activeCalls,
        [callSid]: {
          ...(state.activeCalls[callSid] || {}),
          status: status === 'initiated' && state.activeCalls[callSid] && state.activeCalls[callSid].status ? state.activeCalls[callSid].status : status
        }
      }
    },

    updateCallDuration(state, {callSid, duration}) {
      state.activeCalls = {
        ...state.activeCalls,
        [callSid]: {
          ...(state.activeCalls[callSid] || {}),
          duration
        }
      }
    },
    updateCallContact(state, contact) {
      let callSid = Object.keys(state.activeCalls).find(calSid => {
        return state.activeCalls[calSid].contact.id === contact.id;
      })
      if(callSid) {
        state.activeCalls = {
          ...state.activeCalls,
          [callSid]: {
            ...(state.activeCalls[callSid] || {}),
            contact
          }
        }
      }
    }
  },
  state: {
    activeCalls: {},
    activeVideoSessions: {}
  }
}
